import { useEffect, useState } from "react";
import { Container } from "../../../../components/global";
import { ArrowButton } from "../_00Global/ArrowButton";
import { FyLogo } from "../_00Global/FyLogo";
import { LargeButton } from "../_00Global/LargeButton";
import { _01HeroTvLogos } from "./_01HeroTvLogos";

interface Props {
  className?: string;
}

export const _01Hero = ({ className = "" }: Props): JSX.Element => {
  const handleContactClick = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };
  
  // Track viewport width for responsive text content
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    // Initial check
    setIsMobile(window.innerWidth < 640);
    
    // Update on resize
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Container fullWidth className={`flex flex-col w-full min-w-full h-[864px] items-center justify-center relative bg-[#ccffff] ${className}`}
      style={{ width: '100vw', left: '0', right: '0', boxSizing: 'border-box' }}>
      
      {/* Content wrapped in Container to respect margins */}
      <Container className="flex flex-col items-center justify-center gap-20 py-[70px] relative self-stretch w-full flex-[0_0_auto] mt-[-0.61px] mb-[-0.61px] max-md:gap-0 max-md:pt-[50px] max-md:pb-[90px] max-md:px-[63px]">
        {/* Logo */}
        <FyLogo className="w-[69.99px] h-[74.71px] max-md:w-[76.14px] max-md:h-[81.28px] max-md:mb-[60px]" />
        
        {/* Title, Divider, Subtitle Group */}
        <div className="flex flex-col items-center justify-center gap-10 relative self-stretch w-full flex-[0_0_auto] max-md:gap-[20px] max-md:mb-[80px]">
          {/* Title */}
          <div className="flex flex-col items-center justify-center relative self-stretch w-full flex-[0_0_auto]">
            <div className="relative self-stretch [font-family:'Amatic_SC',Helvetica] font-normal text-[#657d84] text-[80px] text-center tracking-[2.00px] leading-[80px] max-md:text-[75.4px] max-md:tracking-[1.89px] max-md:leading-[75.4px] max-md:mt-[-0.91px]">
              Forever Yours Films
            </div>
          </div>

          {/* Divider */}
          <div className="relative self-stretch w-full flex-[0_0_auto] font-section-divider font-[number:var(--section-divider-font-weight)] text-[#657d84] text-[length:var(--section-divider-font-size)] text-center tracking-[var(--section-divider-letter-spacing)] leading-[var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
            <span className="md:inline hidden">......................................................................................................................................</span>
            <span className="max-md:inline hidden">...............................................................................</span>
          </div>

          {/* Subtitle */}
          <div className="flex flex-col items-center justify-center relative self-stretch w-full flex-[0_0_auto]">
            <p className="relative self-stretch font-hero-subtitle font-[number:var(--hero-subtitle-font-weight)] text-[#657d84] text-[length:var(--hero-subtitle-font-size)] text-center tracking-[var(--hero-subtitle-letter-spacing)] leading-[var(--hero-subtitle-line-height)] [font-style:var(--hero-subtitle-font-style)] max-md:text-[50.2px] max-md:tracking-[2.74px] max-md:leading-[50.2px] max-md:[font-family:'Amatic_SC',Helvetica] max-md:font-normal max-md:mt-[-0.91px] max-md:whitespace-nowrap">
              {isMobile 
                ? "England's No. 1 Wedding Films"
                : "England's Number One Wedding Films"
              }
            </p>
          </div>
        </div>

        {/* TV Logos */}
        <div className="flex flex-col w-[310px] items-center justify-center px-0 py-[10px] relative flex-[0_0_auto] max-md:w-[371.19px] max-md:py-[10.15px] max-md:mb-[80px]">
          <_01HeroTvLogos className="w-[310px] h-[58.54px] max-md:w-[371.19px] max-md:h-[70.09px]" />
        </div>

        {/* Call-to-action buttons */}
        <div className="inline-flex flex-col items-center justify-center gap-10 relative flex-[0_0_auto] max-md:gap-[40px]">
          <ArrowButton
            className="!flex-[0_0_auto] max-md:w-[267.43px]"
            text="Watch Our Videos"
          />
          <LargeButton 
            text="CONTACT US" 
            onClick={handleContactClick}
            className="max-md:w-[360.64px] max-md:h-[67.62px]" 
          />
        </div>
      </Container>
    </Container>
  );
}; 